import { NgModule } from '@angular/core';
import { SharedComponentsModule } from 'tabweeb-shared-components';
import { UserManagementLayoutComponent } from './layouts/user-management-layout/user-management-layout.component';
import { ButtonComponent } from './components/button/button.component';
import { TextInputComponent } from './components/text-input/text-input.component';
import { OtpInputComponent } from './components/otp-input/otp-input.component';
import { HomeIconComponent } from './icons/home-icon/home-icon.component';
import { ArrowDownIconComponent } from './icons/arrow-down-icon/arrow-down-icon.component';
import { SaleIconComponent } from './icons/sale-icon/sale-icon.component';
import { PurchaseIconComponent } from './icons/purchase-icon/purchase-icon.component';
import { DollerIconComponent } from './icons/doller-icon/doller-icon.component';
import { SettingsIconComponent } from './icons/settings-icon/settings-icon.component';
import { SearchV2Component } from './components/search-v2/search-v2.component';
import { FilterV2Component } from './components/filter-v2/filter-v2.component';
import { TableRowActionsComponent } from './components/table-row-actions/table-row-actions.component';
import { LoadingBarComponent } from './components/loading-bar/loading-bar.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ListLayoutComponent } from './layouts/list-layout/list-layout.component';
import { TableV1Component } from './components/table-v1/table-v1.component';
import { TextInputRowComponent } from './components/text-input-row/text-input-row.component';
import { SelectInputRowComponent } from './components/select-input-row/select-input-row.component';
import { TabRouterComponent } from './components/tab-router/tab-router.component';
import { RouterModule } from '@angular/router';
import { CollapsedCardComponent } from './components/collapsed-card/collapsed-card.component';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerRowComponent } from './components/datepicker-row/datepicker-row.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { SelectOrAddComponent } from './components/select-or-add/select-or-add.component';
import { MatTreeModule } from '@angular/material/tree';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ToggleInputComponent } from './components/toggle-input/toggle-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { TranslatorPipe } from './pipe/translator.pipe';
import { UsersIconComponent } from './icons/users-icon/users-icon.component';
import { UploadImageComponent } from './components/upload-image/upload-image.component';
import { UsersIcon1Component } from './icons/users-icon-1/users-icon-1.component';
import { StoreIconComponent } from './icons/store-icon/store-icon.component';
import { SecurityIconComponent } from './icons/security-icon/security-icon.component';
import { PhoneComponentComponent } from './components/phone-component/phone-component.component';
import { AngularPhoneNumberInput } from 'angular-phone-number-input';
import { ScafoldContainerComponent } from './components/scafold-container/scafold-container.component';
import { BooleanTranslatorPipe } from './pipe/boolean-translator.pipe';
import { InputGroupComponent } from './components/input-group/input-group.component';
import { PlanTypePipe } from './pipe/plan-type.pipe';
import { SubscriptionStatusPipe } from './pipe/subscription-status.pipe';
import { ControlTypePipe } from './pipe/control-type.pipe';
import { FeatureTypePipe } from './pipe/feature-type.pipe';
import { SubscriptionTypePipe } from './pipe/subscription-type.pipe';
import { PaymentMethodPipe } from './pipe/payment-method.pipe';
import { PaymentStatusPipe } from './pipe/payment-status.pipe';
import { ThousandSeparatorDirective } from './pipe/thousandSeperation.pipe';
import { EnterAsTabDirective } from './directives/enter-as-tab.directive';
import { MaterialTimePickerComponent } from '@candidosales/material-time-picker';
import { LanguageToggleButtonComponent } from './components/language-toggle-button/language-toggle-button.component';
import { BranchHeaderComponent } from './components/branch-header/branch-header.component';

@NgModule({
  declarations: [
    UserManagementLayoutComponent,
    ButtonComponent,
    TextInputComponent,
    OtpInputComponent,
    HomeIconComponent,
    ArrowDownIconComponent,
    SaleIconComponent,
    PurchaseIconComponent,
    DollerIconComponent,
    SettingsIconComponent,
    SearchV2Component,
    FilterV2Component,
    TableRowActionsComponent,
    LoadingBarComponent,
    PaginationComponent,
    ListLayoutComponent,
    TableV1Component,
    TextInputRowComponent,
    SelectInputRowComponent,
    TabRouterComponent,
    CollapsedCardComponent,
    DatepickerRowComponent,
    DatepickerComponent,
    SelectOrAddComponent,
    BreadcrumbComponent,
    ToggleInputComponent,
    TranslatorPipe,
    UsersIconComponent,
    UploadImageComponent,
    UsersIcon1Component,
    StoreIconComponent,
    SecurityIconComponent,
    PhoneComponentComponent,
    ScafoldContainerComponent,
    BooleanTranslatorPipe,
    InputGroupComponent,
    PlanTypePipe,
    SubscriptionStatusPipe,
    ControlTypePipe,
    FeatureTypePipe,
    SubscriptionTypePipe,
    PaymentMethodPipe,
    PaymentStatusPipe,
    ThousandSeparatorDirective,
    EnterAsTabDirective,
    LanguageToggleButtonComponent,
    BranchHeaderComponent
  ],
  imports: [
    SharedComponentsModule,
    RouterModule,
    NgbCollapseModule,
    NgxDaterangepickerMd.forRoot(),
    MatTreeModule,
    TranslateModule,
    AngularPhoneNumberInput,
    RouterModule,
    MaterialTimePickerComponent
  ],
  providers: [
    // CurrencyService
  ],
  exports: [
    SharedComponentsModule,
    UserManagementLayoutComponent,
    ButtonComponent,
    TextInputComponent,
    OtpInputComponent,
    HomeIconComponent,
    ArrowDownIconComponent,
    SaleIconComponent,
    PurchaseIconComponent,
    DollerIconComponent,
    SettingsIconComponent,
    SearchV2Component,
    FilterV2Component,
    TableRowActionsComponent,
    LoadingBarComponent,
    PaginationComponent,
    ListLayoutComponent,
    TextInputRowComponent,
    SelectInputRowComponent,
    TabRouterComponent,
    CollapsedCardComponent,
    DatepickerComponent,
    DatepickerRowComponent,
    SelectOrAddComponent,
    TableV1Component,
    BreadcrumbComponent,
    ToggleInputComponent,
    TranslatorPipe,
    UsersIconComponent,
    UploadImageComponent,
    UsersIcon1Component,
    StoreIconComponent,
    SecurityIconComponent,
    PhoneComponentComponent,
    ScafoldContainerComponent,
    BooleanTranslatorPipe,
    InputGroupComponent,
    PlanTypePipe,
    SubscriptionStatusPipe,
    ControlTypePipe,
    FeatureTypePipe,
    SubscriptionTypePipe,
    PaymentMethodPipe,
    PaymentStatusPipe,
    ThousandSeparatorDirective,
    EnterAsTabDirective,
    LanguageToggleButtonComponent,
    BranchHeaderComponent
  ],
})
export class SharedModule { }
